import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CloseButton extends Component {
  render() {
    return (
      <div className="browser-audio-close-button" onClick={this.props.closeAudioBrowser}>
        <i className="material-icons browser-audio-close-icon" aria-hidden="true">close</i>
      </div>
    );
  }
}

CloseButton.propTypes = {
  closeAudioBrowser: PropTypes.func.isRequired
};

export default CloseButton;
